export default __webpack_public_path__ + "static/media/inventMgmt2Full.879e1842.png";